goog.provide('el8.tourguide.Hilite');

goog.require('el8.tourguide.InfoBox');


el8.tourguide.Hilite = function(opts) {
    opts = opts || {};
    this._hasInfoBox = (opts.hasInfoBox === true);
    this._infoBoxPositionVert = opts.infoBoxPositionVert || 'bottom'; // 'top', 'bottom', undefined
    this._infoBoxPositionHo = opts.infoBoxPositionHo || ''; // 'left', 'right', undefined
    this._infoBoxOpts = opts.infoBoxOpts || {};
    this._opacity = (opts.opacity === null || opts.opacity == undefined) ?
        0.4 : opts.opacity;
    this._zIndex = (opts.zIndex === null || opts.zIndex == undefined) ?
        1 : opts.zIndex;
    return this;
};

el8.tourguide.Hilite.prototype.show = function($elt, topOffset, buffer, outerBuffer) {

    buffer = buffer || {};
    outerBuffer = outerBuffer || {};
    var offsets = $elt.offset();

    var height = ($elt.outerHeight(true) || 0) + (buffer.top || 0) + (buffer.bottom || 0);
    var width = ($elt.outerWidth(true) || 0) + (buffer.left || 0) + (buffer.right || 0);

    var windowHeight = $(window).height();
    var windowWidth = $(window).width() - (outerBuffer.right || 0);

    var borders = {
        'left': offsets.left - (buffer.left || 0),
        'right': windowWidth - (offsets.left + width) - (buffer.right || 0),
        'top': offsets.top - (topOffset || 0) - (buffer.top || 0),
        'bottom': windowHeight - (offsets.top + height) - (buffer.bottom || 0)
    };

    this._overlay = $('<div class="hilite-overlay">');
    this._overlay.css({
        'opacity': this._opacity,
        'height': height,
        'width': width,
        'position': 'fixed',
        'left': 0,
        'top': (topOffset || 0),
        'background-color': 'none',
        'border-left': borders.left+'px solid',
        'border-right': borders.right+'px solid',
        'border-top': borders.top+'px solid',
        'border-bottom': borders.bottom+'px solid',
        'border-color': 'white',
        'z-index': this._zIndex
    });
    $('body').prepend(this._overlay);

    if (this._hasInfoBox) {
        var BUFFER = 20;
        this._infoBox = new el8.tourguide.InfoBox();
        this._infoBoxOpts.width = this._infoBoxOpts.width || 200;
        this._infoBoxOpts.height = this._infoBoxOpts.height || 100;
        this._infoBoxOpts.left = borders.left +
            (this._infoBoxPositionHo === 'left' ? (-1*this._infoBoxOpts.width - BUFFER) :
             (this._infoBoxPositionHo === 'right' ? (width + BUFFER) : BUFFER));
        this._infoBoxOpts.top = borders.top +
            (this._infoBoxPositionVert === 'bottom' ? (height + BUFFER) :
             (this._infoBoxPositionVert === 'top' ? (-1*this._infoBoxOpts.height - BUFFER) : BUFFER));
        this._infoBox.show(this._infoBoxOpts);
    }
};


el8.tourguide.Hilite.prototype.hide = function($elt) {
    if (this._overlay) { this._overlay.remove(); }
    if (this._infoBox) { this._infoBox.hide(); }
};

el8.tourguide.Hilite.prototype.getInfoBoxContainer = function() {
    if (this._infoBox) { return this._infoBox.getContainer(); }
};

